const name = {
    defaultMessage: 'Genesis Dark',
    description: 'Label for the genesis dark GUI theme',
    id: 'tw.theme.gui.genesis dark'
};

const guiColors = {
    'color-scheme': 'dark',

    'ui-primary': '#000000',
    'ui-secondary': '#0e0e0e',
    'ui-tertiary': '#0F0F0F',

    'ui-modal-overlay': 'var(--looks-secondary-dark)',
    'ui-modal-background': 'black',
    'ui-modal-foreground': 'white',
    'ui-modal-header-background': 'black',
    'ui-modal-header-foreground': 'white',

    'ui-white': '#000000',

    'ui-black-transparent': '#ffffff26',

    'text-primary': 'var(--looks-secondary)',

    'menu-bar-background': 'black',

    'assets-background': '#000000',

    'input-background': '#0F0F0F',

    'popover-background': '#0F0F0F',

    'badge-background': '#2C1624',
    'badge-border': '#52204B',

    'fullscreen-background': 'black',
    'fullscreen-accent': 'var(--looks-secondary)',

    'page-background': 'black',
    'page-foreground': 'white',

    'project-title-inactive': 'var(--ui-secondary)',
    'project-title-hover': '#ffffff3f',

    'link-color': '#44aaff',

    'filter-icon-black': 'invert(100%)',
    'filter-icon-gray': 'grayscale(100%) brightness(1.7)',
    'filter-icon-white': 'brightness(0) invert(100%)',

    'paint-filter-icon-gray': 'brightness(1.7)'
};

const blockColors = {
    insertionMarker: '#cccccc',
    workspace: '#0F0F0F',
    toolboxSelected: '#0F0F0F',
    toolboxText: '#cccccc',
    toolbox: '#000000',
    flyout: '#000000',
    scrollbar: '#666666',
    valueReportBackground: '#0F0F0F',
    valueReportBorder: '#333333',
    valueReportForeground: '#eeeeee',
    contextMenuBackground: '#000000',
    contextMenuBorder: '#ffffff26',
    contextMenuForeground: '#eeeeee',
    contextMenuActiveBackground: '#2e2e2e',
    contextMenuDisabledForeground: '#666666',
    flyoutLabelColor: '#cccccc',
    checkboxInactiveBackground: '#222222',
    checkboxInactiveBorder: '#c8c8c8',
    buttonBorder: '#c6c6c6',
    buttonActiveBackground: '#222222',
    buttonForeground: '#cccccc',
    zoomIconFilter: 'invert(100%)',
    gridColor: 'transparent'
};

export {
    name,
    guiColors,
    blockColors
};
